import { createApp } from 'vue'
import App from './App.vue'
import Router from './router/router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css';
import { createPinia } from 'pinia'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'



const app = createApp(App)

// 引入图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

const statusList = [
    {
        // todo null 空字符串或者null
        value: 'null',
        label: '全部'
    }, {
        value: 1,
        label: '草稿'
    }, {
        value: 2,
        label: '发布'
    }, {
        value: 3,
        label: '上架'
    }, {
        value: 4,
        label: '进行中'
    }, {
        value: 5,
        label: '结束'
    }]
function formatStatus(data) {
    for (let i = 0; i < statusList.length; i++) {
        if(data.status == statusList[i].value){
            return statusList[i].label
        }
    }
}
// 抽开机卡盒类型
const cardType = [
     {
         value: 1,
         label: '宝可梦简中'
     },
     {
        value: 2,
        label: '宝可梦日版'
     },
    {
        value: 3,
        label: '其他'
    }
]

// 拼团奖品等级
const teamType = [
    {
        value: '1',
        label: '商品'
    },
    {
        value: '2',
        label: '卡密'
    },
    {
        value: '3',
        label: '欧皇'
    }
]

// 拼团车的类型
const teamCarType = [
    {
        value: '1',
        label: '宝可梦'
    },
    {
        value: '2',
        label: '游戏王'
    },
    {
        value: '3',
        label: '火影'
    },
    {
        value: '4',
        label: '其他'
    }
]

// 盲盒使用的等级
const rankList_Blind = [
    {
        value: 'A',
        label: 'A赏'
    }, {
        value: 'B',
        label: 'B赏'
    }, {
        value: 'C',
        label: 'C赏'
    }, {
        value: 'D',
        label: 'D赏'
    }, {
        value: 'E',
        label: 'E赏'
    }, {
        value: 'F',
        label: 'F赏'
    }, {
        value: 'G',
        label: 'G赏'
    }, {
        value: 'H',
        label: 'H赏'
    }, {
        value: 'I',
        label: 'I赏'
    }, {
        value: 'J',
        label: 'J赏'
    }, {
        value: 'K',
        label: 'K赏'
    }, {
        value: 'L',
        label: 'L赏'
    }, {
        value: 'M',
        label: 'M赏'
    }, {
        value: 'N',
        label: 'N赏'
    }, {
        value: 'O',
        label: 'O赏'
    }, {
        value: 'P',
        label: 'P赏'
    }, {
        value: 'Q',
        label: 'Q赏'
    }, {
        value: 'R',
        label: 'R赏'
    }, {
        value: 'S',
        label: 'S赏'
    }, {
        value: 'T',
        label: 'T赏'
    }, {
        value: 'U',
        label: 'U赏'
    }, {
        value: 'V',
        label: 'V赏'
    }, {
        value: 'W',
        label: 'W赏'
    }, {
        value: 'X',
        label: 'X赏'
    }, {
        value: 'Y',
        label: 'Y赏'
    }, {
        value: 'Z',
        label: 'Z赏'
    }
]

// 一番赏使用的等级
const rankList_One = [...rankList_Blind, {
    value: 'Last',
    label: '终赏'
}]

function formatRank_Blind(data){
    for (let i = 0; i < rankList_Blind.length; i++) {
        if(data.prizeRankType == rankList_Blind[i].value){
            return rankList_Blind[i].label
        }
    }
}

function formatRank_One(data){
    for (let i = 0; i < rankList_One.length; i++) {
        if(data.prizeRankType == rankList_One[i].value){
            return rankList_One[i].label
        }
    }
}

const orderList = [
    {
        value: 1,
        label: '待发货'
    }, {
        value: 2,
        label: '已发货'
    }, {
        value: 3,
        label: '已收货'
    }, {
        value: 4,
        label: '申诉中'
    }, {
        value: 5,
        label: '已完成'
    }]

function orderStatus(data) {
    for (let i = 0; i < orderList.length; i++) {
        if(data.status == orderList[i].value){
            return orderList[i].label
        }
    }
}

function formatDisabled(data) {
    if (data.disable == 0) {
        return "有效"
    } else {
        return "失效"
    }
}

const playType = [{
    value: 1,
    label: '福袋'
}, {
    value: 2,
    label: '盲盒'
}, {
    value: 3,
    label: '一番赏'
}, {
    value: 4,
    label: '抽卡机'
}, {
    value: 5,
    label: '商城'
}, {
    value: 6,
    label: '抽奖'
}, {
    value: 7,
    label: '拼团'
}, {
    value: 8,
    label: '打拳'
}, {
    value: 9,
    label: '翻翻乐'
}]

const pointTypeList = [...playType,
    {
    value: 10001,
    label: '拆解'
}, {
    value: 10002,
    label: '商城兑换'
}, {
    value: 10003,
    label: '福袋回退'
}, {
    value: 10004,
    label: '拼团回退'
}, {
    value: 10005,
    label: '打拳回退'
}]

function formatPointType(data) {
    for (let i = 0; i < pointTypeList.length; i++) {
        if(data.pointType == pointTypeList[i].value){
            return pointTypeList[i].label
        }
    }
}

function formatCardType(data) {
    for (let i = 0; i < cardType.length; i++) {
        console.log(data)
        if(data == cardType[i].value){
            return cardType[i].label
        }
    }
}

function formatTeamType(data) {
    for (let i = 0; i < teamType.length; i++) {
        if(data == teamType[i].value){
            return teamType[i].label
        }
    }
}

function formatTeamCarType(data) {
    for (let i = 0; i < teamCarType.length; i++) {
        if(data == teamCarType[i].value){
            return teamCarType[i].label
        }
    }
}

app.config.globalProperties.$statusList = statusList;

app.config.globalProperties.$formatStatus = formatStatus;

app.config.globalProperties.$orderStatus = orderStatus;

app.config.globalProperties.$rankList_Blind = rankList_Blind;

app.config.globalProperties.$formatRank_Blind = formatRank_Blind;

app.config.globalProperties.$rankList_One = rankList_One;

app.config.globalProperties.$formatRank_One = formatRank_One;

app.config.globalProperties.$formatDisabled = formatDisabled;

app.config.globalProperties.$pointTypeList = pointTypeList;

app.config.globalProperties.$formatPointType = formatPointType;

app.config.globalProperties.$cardType = cardType;
app.config.globalProperties.$formatCardType = formatCardType;

app.config.globalProperties.$teamType = teamType;
app.config.globalProperties.$formatTeamType = formatTeamType;

app.config.globalProperties.$teamCarType = teamCarType;
app.config.globalProperties.$formatTeamCarType = formatTeamCarType;

app.use(Router)
app.use(ElementPlus)
app.use(createPinia())
app.mount('#app')
